import { fetchCatalogsIfNeeded, getCatalog } from './catalog';
import { fetchBidLimitBalanceIfNeeded } from './bidLimit';
import { fetchCatalogBiddingIfNeeded } from './catalogBiddingInfo';
import { fetchCatalogCuratorsIfNeeded } from './catalogCurators';
import { fetchCatalogDetailsIfNeeded } from './catalogDetail';
import { fetchCatalogFeaturedIfNeeded } from './catalogFeatured';
import { fetchCatalogItemsIfNeeded } from './catalogItems';
import { fetchCoverLotsIfNeeded } from './coverLots';
import { fetchCurrencyConversionsIfNeeded } from '@/redux/modules/currency';
import { fetchSellerFollowerCount } from './sellerFollowerCount';
import { fetchSellerRatingsByIdIfNeeded } from './sellerRatings';
import { fetchSellersDetailsIfNeeded } from './sellerDetail';
import { fetchSellersIfNeeded } from './seller';
import { fetchTopSellersIfNeeded } from './topRatedSellers';
import { getNotFoundUrl } from '@/utils/urls';
import { push } from 'connected-react-router';

/* ACTION CREATORS */
export const fetchDataForCatalogPage = (catalogId: number) => async (dispatch: Function, getState: Function) => {
    await Promise.all([
        dispatch(fetchCatalogsIfNeeded([catalogId])),
        dispatch(fetchBidLimitBalanceIfNeeded(catalogId)),
        dispatch(fetchCatalogFeaturedIfNeeded(catalogId)),
        dispatch(fetchCatalogBiddingIfNeeded(catalogId)),
        dispatch(fetchCatalogItemsIfNeeded(catalogId)),
        dispatch(fetchCatalogDetailsIfNeeded([catalogId])),
        dispatch(fetchCoverLotsIfNeeded([catalogId])),
        dispatch(fetchCatalogCuratorsIfNeeded(catalogId)),
        dispatch(fetchTopSellersIfNeeded()),
        dispatch(fetchCurrencyConversionsIfNeeded()),
    ]);

    const state = getState();
    const catalog = getCatalog(state, catalogId);

    if (!catalog || !catalog.catalogId) {
        return dispatch(push(getNotFoundUrl()));
    }

    return Promise.all([
        dispatch(fetchSellersIfNeeded([catalog.sellerId])),
        dispatch(fetchSellersDetailsIfNeeded([catalog.sellerId])),
        dispatch(fetchSellerFollowerCount([catalog.sellerId])),
        dispatch(fetchSellerRatingsByIdIfNeeded({ sellerId: catalog.sellerId })),
    ]);
};
